export const SPARKJS_LATEST_VERSION = 'latest';

export const SPARKJS_V2_VERSION = '2.0.0';

/** Fallback SparkLayer Core Script version for stores that have never been pinned to one. */
export const SPARKJS_LEGACY_FALLBACK_VERSION = '1.36.x';

export const WIDGET_TABS = ['core', 'pdp', 'css', 'tips'] as const;

export type WidgetTab = (typeof WIDGET_TABS)[number];
